// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o1HeqghllqIctRrpRz0z{max-height:100%;z-index:var(--zIndex-OVERLAY_MAIN_1);opacity:0;border-radius:4px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)scale(1.25)}.SDKyuEVLnQEibOye5gQ7{opacity:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `o1HeqghllqIctRrpRz0z`,
	"ready": `SDKyuEVLnQEibOye5gQ7`
};
export default ___CSS_LOADER_EXPORT___;
